export default "__VITE_PUBLIC_ASSET__f67eac53__"